import { render, staticRenderFns } from "./Dataprotection.vue?vue&type=template&id=52482448&scoped=true"
import script from "./Dataprotection.vue?vue&type=script&lang=ts"
export * from "./Dataprotection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52482448",
  null
  
)

export default component.exports